import { useIntl, defineMessages } from 'react-intl'

import { Select } from 'components/v2/Select'
import { CONTAINERS } from 'features/Snacks/components/Containers/constants'
import { containersMessages } from 'features/Snacks/components/Containers/messages'

const CONTAINERS_LIST = [CONTAINERS.CAN, CONTAINERS.PET, CONTAINERS.BAG, CONTAINERS.PACKAGE]

const messages = defineMessages({
  selectContainer: {
    id: 'spanish.dictionary.selectContainer',
    defaultMessage: 'Seleccionar envase'
  }
})

export const SelectContainer = (props: TSFixMe): TSFixMe => {
  const intl = useIntl()

  return (
    <Select {...props}>
      <option value="">{intl.formatMessage(messages.selectContainer)}</option>

      {CONTAINERS_LIST.map((container): TSFixMe => {
        return (
          <option value={container} key={container}>
            {intl.formatMessage(containersMessages[container])}
          </option>
        )
      })}
    </Select>
  )
}
